export const getFailedItems = (error: { getData: () => { [key: string]: any }[] }) => (
  (('getData' in error) && error.getData()?.[0]) || {}
);
